export enum AnalyticsEvent {
  UpgradeContractRequestViewed = 'upgradeContractRequestViewed',
  UpgradeContractRequested = 'upgradeContractRequested',
  UpgradeContractRequestConfirmation = 'upgradeContractRequestConfirmation',
  UserLogin = 'userLogin',
  UserLoaded = 'userLoaded',
}
